import React, { useContext, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import Im from "immutable";
import AzureSSOButton, { doAzureSSOLogin, mustUseAzure } from "./azure";
import { AuthContext } from "./context";
import useToken from "./token";
import { InputField } from "./formItems";

export function LoginPage(props) {
  return (
    <div className="container">
      <h3>Welcome to the product carbon calculator</h3>
      <LoginForm />
    </div>
  );
}

export function CreateAccountButton({ hide, createText }) {
  if (hide) return null;
  return (
    <div className="text-center border-top pt-3">
      <Link to="/accounts/register/">
        <b>{createText || "Create an account"}</b>
      </Link>
    </div>
  );
}

const submitLoginForm = (e, host, getToken, setErrors) => {
  e.preventDefault();
  const formData = new FormData(e.target);
  const data = Object.fromEntries(formData.entries());
  getToken(data, host, (data) => setErrors(Im.fromJS(data)));
};

export function ErrorAlert({ errors }) {
  const error = errors?.get("detail");
  if (!error) {
    return null;
  }
  return <div className="alert alert-danger">{error}</div>;
}

export default function LoginForm(props) {
  const { hideCreateAccount } = props;
  const { host, azureConfig, hideMicrosoftSSO, postLoginPage } =
    useContext(AuthContext);
  const { isAuthenticated, getToken } = useToken();
  const [errors, setErrors] = useState(null);
  const [canLoginDirectly, setCanLoginDirectly] = useState(false);
  const [username, setUsername] = useState(null);

  if (isAuthenticated && postLoginPage) {
    return <Redirect to={postLoginPage} />;
  }

  const onFailure = (data) => {
    setErrors(Im.fromJS(data))
    setUsername(null)
  }

  return (
    <div className="card shadow p-4 bg-white rounded border-0">
      {!username && (
        <form
          className="form"
          onSubmit={(e) => {
            e.preventDefault();
            const enteredIdentifier = e.target[0].value;
            setUsername(enteredIdentifier);
            if (enteredIdentifier.includes("@")) {
              if (mustUseAzure({ email: enteredIdentifier })) {
                setCanLoginDirectly(false);
              } else {
                setCanLoginDirectly(true);
              }
            } else {
              setCanLoginDirectly(true);
            }
          }}
        >
          <ErrorAlert errors={errors} />
          <InputField
            attribute="username"
            placeholder="Username or Email"
            errors={errors}
          />
          <div className="form-group">
            <button className="btn btn-sm btn-primary btn-block" type="submit">
              Next
            </button>
          </div>
          <CreateAccountButton hide={hideCreateAccount} />
        </form>
      )}
      <form
        className="form"
        onSubmit={(e) => submitLoginForm(e, host, getToken, onFailure)}
      >
        {username && canLoginDirectly && (
          <>
            <input name="username" type="hidden" value={username} />
            <InputField
              attribute="password"
              placeholder="Password"
              helpBlock={<PasswordHelp />}
              fieldType="password"
              errors={errors}
            />
            <div className="form-group">
              <button
                className="btn btn-sm btn-primary btn-block"
                type="submit"
              >
                Login
              </button>
            </div>
          </>
        )}
        <AzureSSOButton
          hide={hideMicrosoftSSO}
          showTopSeparator
          config={{ ...azureConfig, register: false }}
        />
      </form>
    </div>
  );
}

function PasswordHelp() {
  return (
    <div>
      <small
        id="passwordHelpBlock"
        className="form-text text-muted float-right"
      >
        <Link to="/accounts/password/reset/">Reset your password</Link>
      </small>
      <div style={{ clear: "both" }} />
    </div>
  );
}
